/**
 * @desc 贴标管理交货单列表导出
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierDeliveryOrder.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierDeliveryOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
